var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "listPage" },
    [
      _vm.activateSpinner
        ? _c("spinner", { staticClass: "mt-3" })
        : _c("div", [
            _vm.items.length
              ? _c(
                  "table",
                  {
                    staticClass: "table table-striped",
                    attrs: {
                      role: "table",
                      "aria-label": _vm.$t("orphan.orphan_list_table"),
                    },
                  },
                  [
                    _c("caption", { staticClass: "sr-only" }, [
                      _vm._v(_vm._s(_vm.$t("orphan.orphan_list_caption"))),
                    ]),
                    _vm._v(" "),
                    _c("thead", [
                      _c(
                        "tr",
                        _vm._l(_vm.fields, function (field) {
                          return _c(
                            "th",
                            {
                              key: field.key,
                              class: field.class,
                              attrs: { scope: "col" },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(field.label) +
                                  "\n          "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.items, function (item, index) {
                        return _c(
                          "tr",
                          {
                            key: index,
                            staticClass: "cursor-pointer",
                            on: {
                              click: function ($event) {
                                return _vm.seeOrphansDetails([item])
                              },
                            },
                          },
                          [
                            _c("td", { class: _vm.fields[0].class }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.getDate(item.CreationDate))),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", { class: _vm.fields[1].class }, [
                              _c("div", { staticClass: "text-ellipsis" }, [
                                _vm._v(_vm._s(item.Reference)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", { class: _vm.fields[2].class }, [
                              _c("div", { staticClass: "text-ellipsis" }, [
                                _vm._v(
                                  _vm._s(
                                    item.CompanyName != ""
                                      ? item.CompanyName
                                      : item.FirstName + " " + item.LastName
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", { class: _vm.fields[3].class }, [
                              _c("div", { staticClass: "text-ellipsis" }, [
                                _vm._v(
                                  _vm._s(
                                    item.IdScore != ""
                                      ? item.IdScore
                                      : item.NameScore
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", { class: _vm.fields[4].class }, [
                              _c("div", { staticClass: "text-ellipsis" }, [
                                _vm._v(_vm._s(item.Type)),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                )
              : _c("div", { staticClass: "d-flex justify-content-center" }, [
                  _c("span", { staticClass: "noResult" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("common.no_result")) +
                        "\n      "
                    ),
                  ]),
                ]),
          ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-5" },
        [
          _c(
            "b-col",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("cm-pagination", {
                    attrs: {
                      maxResultsByPage: _vm.paginationObject.maxResults,
                      firstIndex: _vm.paginationObject.firstIndex,
                      nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                      refreshEvent: _vm.paginationObject.refresh,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }